module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.myTeamGroups.length > 0) ? _c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "channelBtn w-100 btn bg-lightest radius-normal darker bold fs-large",
    class: {
      'selected': _vm.value.length > 0 && _vm.value[0].channelType == 9999
    },
    on: {
      "click": function($event) {
        return _vm.selectChannel('myTeam')
      }
    }
  }, [_c('div', {}, [_c('span', {
    staticClass: "myTeamTitle"
  }, [_vm._v("My team")]), _vm._v(" "), _vm._l((_vm.myTeamGroups), function(group) {
    return _c('div', {
      staticClass: "myTeamGroup fs-smaller"
    }, [_vm._v("\n                    " + _vm._s(group.name) + "\n                ")])
  })], 2)])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.regularChannels), function(salesChannel) {
    return _c('div', {
      staticClass: "col-sm-3"
    }, [_c('button', {
      staticClass: "channelBtn w-100 btn bg-lightest radius-normal darker bold fs-large",
      class: {
        'selected': _vm.value.length > 0 && _vm.value[0].id == salesChannel.id
      },
      on: {
        "click": function($event) {
          return _vm.selectChannel(salesChannel)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(salesChannel.name))])])])
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5e4aae0d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e4aae0d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/refund/ChannelSelector.vue
// module id = 1999
// module chunks = 0